// extracted by mini-css-extract-plugin
export default {"addToCartControl":"XW-z","giftCard":"YW-z","btnContainer":"ZW-z","cartButton":"_W-z","disabled":"aX-z","stockMessage":"bX-z"};